import { render, staticRenderFns } from "./Amplification.vue?vue&type=template&id=0b7bdf31&scoped=true&"
import script from "./Amplification.vue?vue&type=script&lang=js&"
export * from "./Amplification.vue?vue&type=script&lang=js&"
import style0 from "./Amplification.vue?vue&type=style&index=0&id=0b7bdf31&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7bdf31",
  null
  
)

export default component.exports